import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  ChevronRight,
  Globe,
  Users,
  Shield,
  Database,
  Settings as SettingsIcon,
  User,
  Lock,
  ShoppingCart,
  UserCheck,
  Lightbulb,
  Upload,
  Package,
  Factory,
  Award,
  Tag,
  Wrench,
  Cog,
  CreditCard,
  Calculator,
  Hash,
  Sliders,
  FileSearch,
  Building,
  MapPin,
  Phone,
  Mail,
  Calendar,
  Clock,
  DollarSign,
  Target,
  BarChart3,
  TrendingUp,
  Activity,
  Zap,
  CheckCircle,
  AlertTriangle,
  Info,
  Plus,
  Edit,
  Eye,
  Trash2
} from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import { useNavigate } from 'react-router-dom'
import settingsService from '../../services/settingsService'
// Consolidated CSS is imported globally

const GlobalMaster = () => {
  const navigate = useNavigate()
  const [counts, setCounts] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await settingsService.getDashboardData()
        if (!cancelled && res?.success) {
          setCounts({
            companies: res.data?.masterData?.companies ?? res.data?.metrics?.totalCompanies,
            departments: res.data?.masterData?.departments ?? res.data?.metrics?.totalDepartments,
          })
        }
      } catch (_) { /* empty */ }
      finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [])

  const labelCount = (n, singular, plural = `${singular}s`) => {
    if (loading) return '…'
    if (n == null) return '—'
    return `${n} ${n === 1 ? singular : plural}`
  }

  const handleBack = () => {
    navigate('/settings')
  }

  const handleCardClick = (cardType) => {
    console.log(`Clicked on ${cardType}`)
    // Add navigation logic for each card type
    if (cardType === 'Company') {
      navigate('/settings/company-master')
    } else if (cardType === 'Dropdown Master') {
      navigate('/dropdown-master')
    }
  }

  // Breadcrumb items
  const breadcrumbItems = [
    {
      label: 'Settings',
      path: '/settings',
      onClick: () => navigate('/settings')
    },
    {
      label: 'Masters',
      path: '/settings',
      onClick: () => navigate('/settings')
    },
    {
      label: 'Global Master',
      path: '/settings/global-master',
      isCurrent: true
    }
  ]

  return (
    <div className="sales-dashboard">
      {/* Breadcrumb Navigation */}
      <div className="breadcrumb-section">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      {/* Page Header */}
      <div className="page-header">
        <div className="page-title">
          <h1>Global Master</h1>
          <p>Manage global system configurations and settings</p>
        </div>
      </div>

      {/* Master Cards Grid */}
      <div className="settings-masters-grid">
        {/* Company */}
        <div className="settings-master-card" onClick={() => handleCardClick('Company')}>
          <div className="settings-master-icon">
            <Building size={24} />
          </div>
          <div className="settings-master-content">
            <h3>Company</h3>
            <p>Manage company details and business information</p>
            <div className="settings-master-count">{labelCount(counts?.companies, 'Company', 'Companies')}</div>
          </div>
        </div>

        {/* Department Master */}
        <div className="settings-master-card" onClick={() => handleCardClick('Department Master')}>
          <div className="settings-master-icon">
            <Users size={24} />
          </div>
          <div className="settings-master-content">
            <h3>Department Master</h3>
            <p>Organize departments and teams</p>
            <div className="settings-master-count">{labelCount(counts?.departments, 'Department')}</div>
          </div>
        </div>

        {/* UoM Master */}
        <div className="settings-master-card" onClick={() => handleCardClick('UoM Master')}>
          <div className="settings-master-icon">
            <Package size={24} />
          </div>
          <div className="settings-master-content">
            <h3>UoM Master</h3>
            <p>Manage units of measurement</p>
            <div className="settings-master-count">—</div>
          </div>
        </div>

        {/* Report QMS Mapping */}
        <div className="settings-master-card" onClick={() => handleCardClick('Report QMS Mapping')}>
          <div className="settings-master-icon">
            <BarChart3 size={24} />
          </div>
          <div className="settings-master-content">
            <h3>Report QMS Mapping</h3>
            <p>Quality management system report mappings</p>
            <div className="settings-master-count">—</div>
          </div>
        </div>

        {/* Document Type */}
        <div className="settings-master-card" onClick={() => handleCardClick('Document Type')}>
          <div className="settings-master-icon">
            <FileSearch size={24} />
          </div>
          <div className="settings-master-content">
            <h3>Document Type</h3>
            <p>Define document categories and types</p>
            <div className="settings-master-count">—</div>
          </div>
        </div>

        {/* Document Master */}
        <div className="settings-master-card" onClick={() => handleCardClick('Document Master')}>
          <div className="settings-master-icon">
            <FileSearch size={24} />
          </div>
          <div className="settings-master-content">
            <h3>Document Master</h3>
            <p>Manage document templates and standards</p>
            <div className="settings-master-count">—</div>
          </div>
        </div>

        {/* Dropdown Master */}
        <div className="settings-master-card" onClick={() => handleCardClick('Dropdown Master')}>
          <div className="settings-master-icon">
            <Sliders size={24} />
          </div>
          <div className="settings-master-content">
            <h3>Dropdown Master</h3>
            <p>Manage dropdown options and lists</p>
            <div className="settings-master-count">—</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GlobalMaster
